import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import DetailDeFacturationComponent from '../../../components/Mouvement/Panel/DetailDeFacturationComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class DetailDeFacturationPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.DETAIL_DE_FACTURATION;
		this.defaultSize = 6;
		this.icon = { name: 'th list' };
	}

	getLibelle = () => 'Détail de facturation';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find(
			(ligne) =>
				ligne?.lfacMtbase ||
				ligne?.lfacLibelle ||
				ligne?.lfacMtremise ||
				ligne?.lfacMtunitaire ||
				ligne?.lfacQuantite ||
				ligne?.lfacUnite1 ||
				ligne?.lfacDate ||
				ligne?.lfacDatefin,
		);

	isComplete = (data: Mouvement) =>
		this.everyLigneHas(
			data,
			'lfacMtbase',
			'lfacLibelle',
			'lfacMtremise',
			'lfacMtunitaire',
			'lfacQuantite',
			'lfacUnite1',
			'lfacDate',
			'lfacDatefin',
		);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<DetailDeFacturationComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default DetailDeFacturationPanel;
